import React from "react";

import style from "./style.module.css";

export default function Text({ className = "", children, tag = "p", color }) {
    const Tag = tag;
    return (
        <Tag className={`${style.text}${style[className] ? ` ` + style[className] : ''}${style[color] ? ` ` + style[color] : ''}`}>{children}</Tag>
    )
}